export default {"src":"/_next/static/media/rating-5.b9c55aaa.svg","height":96,"width":512,"blurWidth":0,"blurHeight":0};